export enum BannerType {
  Info = 'info',
  Warning = 'warning',
}

export interface BannerConfig {
  type: BannerType;
  message: string;
}

export type BannerContent = string | BannerConfig;

export function isBannerConfig(value: unknown): value is BannerConfig {
  return (
    typeof value === 'object' &&
    value !== null &&
    'message' in value &&
    typeof (value as BannerConfig).message === 'string' &&
    (value as BannerConfig).message.trim().length > 0 &&
    'type' in value &&
    Object.values(BannerType).includes((value as BannerConfig).type)
  );
}
